import { render, staticRenderFns } from "./TeacherPageTable.vue?vue&type=template&id=36d75139&scoped=true&"
import script from "./TeacherPageTable.vue?vue&type=script&lang=js&"
export * from "./TeacherPageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d75139",
  null
  
)

export default component.exports